export default __webpack_public_path__ + "static/media/Days_19.9fc87806.png";